import * as React from 'react';
import { useState, useEffect, useRef, useMemo} from 'react';

import '../../../../../styles/mapbox-gl.css'
import '../../../styles/FieldManager.scss';

import _ from "lodash";
import DeckGL from '@deck.gl/react';
import MapGL from 'react-map-gl'; 
import ESRI_BASE from '../../../components/Map/styles/esri-base.json';

import * as turf from '@turf/turf';
import { ViewState } from 'react-map-gl-draw/node_modules/@types/react-map-gl';
import { getViewport, zoomToFeature } from '../../../utils/mapUtils';
import { Field, DataSourceRasterLayer } from "../../../types/types";
//import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import { NavigationControl, StaticMap, ScaleControl, Popup, Source, Layer } from 'react-map-gl';
//import { MapLayer } from "../../../deckgl/MapLayer";
import { useUnitConversion, formatUnitAbbreviation} from '../../../utils/unitConversion';
import { dcRound } from '../../../utils/misc';

import 'ol/ol.css';
import OLMap from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { fromLonLat } from 'ol/proj';
import OSM from 'ol/source/OSM';
import { Extent } from 'ol/extent';
import ScaleLine from 'ol/control/ScaleLine';
//import { getViewport } from '../../../utils/mapUtils';
//import { Field, DataSourceRasterLayer } from "../../../types/types";
import { MapLayer } from "../../../deckgl/MapLayer";
import { useStore } from '../../../providers/AppProvider';


type StatsProps = {
    metric: string;
    description: string;
    loading: boolean;
    rasterDataSources:DataSourceRasterLayer[];
    bbCardDataSources:DataSourceRasterLayer[];
    selectedPlantObj:any | null;
    selectedField: Field | null;
    bbCardDataCounter:Number;
    setBbCardDataCounter:Function;
    dataCanopyArea: any | null;
    dataCanopyHeight: any | null;
    dataCanopyVolume: any | null;
    propertyUnitsData: any | null;
    dateArrayIndexSelected:number;
    dataCanopyVVI: any | null;
    dataCanopyPGI: any | null;
    dataCanopyTIR: any | null;
    dataCPI: any | null;
    mapLayers:MapLayer[];
    dateArrayDateStringSelected:string;
}

const AboveWidgetImagery = ({ 
    metric,
    description,
    loading,
    rasterDataSources,
    bbCardDataSources,
    selectedPlantObj,
    selectedField,
    bbCardDataCounter,
    setBbCardDataCounter,
    dataCanopyArea, 
    dataCanopyHeight, 
    dataCanopyVolume,
    propertyUnitsData,
    dateArrayIndexSelected,
    dataCanopyVVI,
    dataCanopyPGI,
    dataCanopyTIR,
    dataCPI,
    mapLayers,
    dateArrayDateStringSelected
}: StatsProps) => {
    /*console.log("J111423 bbCardDataSources", bbCardDataSources)   
    console.log("J111423 rasterDataSources", rasterDataSources)   
    console.log("J111423 selectedPlantObj", selectedPlantObj)
    console.log("J111423 selectedField", selectedField)
    console.log("J111423 dataCanopyArea", dataCanopyArea)
    console.log("J111523 dataCanopyHeight", dataCanopyHeight)
    console.log("J111423 dataCanopyVolume", dataCanopyVolume)
    console.log("J111423 propertyUnitsData", propertyUnitsData)
    console.log("A053024 dateArrayIndexSelected", dateArrayIndexSelected)
    console.log("A053024 dateArrayDateStringSelected", dateArrayDateStringSelected)
    console.log("A053024 dataCanopyVVI", dataCanopyVVI)
    console.log("A053024 dataCanopyPGI", dataCanopyPGI)
    console.log("A053024 dataCanopyTIR", dataCanopyTIR)
    console.log("A053024 dataCPI", dataCPI)
    console.log("K111523 mapLayers", mapLayers)*/

    //const [viewportBB, setViewportBB] = useState<ViewState | null>(getViewport(`@${selectedPlantObj.geometry.coordinates[1]},${selectedPlantObj.geometry.coordinates[0]},21`)); // (getViewport(`@36.80052,-120.18320,30`));
    const [tileLayerOverlays, setTileLayerOverlays] = useState<DataSourceRasterLayer[]>([]);
    const [tileLayer, setTileLayer] = useState<DataSourceRasterLayer[]>([]);
    const [fieldMaxMinHeight, setFieldMaxMinHeight] = useState<Array<number>>([6,6]); // Hard-code max to 6 meters for now.  
    const [canopyTop, setCanopyTop] = useState<number>(100);
    const [canopyBottom, setCanopyBottom] = useState<number>(0);
    const [zoomToUse, setZoomToUse] = useState<number>(22);
    const [preferredLenAbbr, setPreferredLenAbbr] = useState<string>("");
    const [preferredAreaAbbr, setPreferredAreaAbbr] = useState<string>("ac");
    const [refreshIncrement, setRefreshIncrement] = useState<number>(0);
    const mapRef = useRef<OLMap | null>(null);
    const mapContainerRef = useRef<HTMLDivElement | null>(null);
    const tileLayerRef = useRef<TileLayer<XYZ> | null>(null);
    
    const [viewportBB, setViewportBB] = useState<any | null>(
        selectedPlantObj?.geometry?.coordinates
            ? getViewport(`@${selectedPlantObj.geometry.coordinates?.[1] || 0},${selectedPlantObj.geometry.coordinates?.[0] || 0},${zoomToUse}`)
            : null
    );
    
    const { localePreferences } = useStore();
    const { convertToPreferredUnitValue, convertToPreferredUnitString, unitsConvert } = useUnitConversion();
    //console.log("A081925 localePreferences", localePreferences);

    useEffect(() => {
        if (!mapContainerRef.current || preferredLenAbbr == "") return;
        console.log("M081925 preferredLenAbbr", preferredLenAbbr);
        let center = fromLonLat([0, 0]);
        let zoom = 2;
        let maxZoom = 21;
        let minZoom = 1;

        if (selectedPlantObj?.geometry?.coordinates) {
            const [lon, lat] = selectedPlantObj.geometry.coordinates;
            if (typeof lon === 'number' && typeof lat === 'number') {
                const vp = getViewport(`@${lat},${lon},${zoomToUse}`);
                setViewportBB(vp);
                center = fromLonLat([vp.longitude, vp.latitude]);
                zoom = vp.zoom; //24;
                maxZoom = 28;
            }
        } else {
            setViewportBB(null);
        }

        // Safe check for bbCardDataSources & tiles
        let newTileLayer: TileLayer<XYZ> | null = null;
        if (Array.isArray(bbCardDataSources) && bbCardDataSources.length > 0) {
            const source = bbCardDataSources[0];
            if (source && Array.isArray(source.tiles) && source.tiles.length > 0 && typeof source.tiles[0] === 'string') {
                newTileLayer = new TileLayer({
                    source: new XYZ({
                        url: source.tiles[0],
                        tileSize: 256,
                    }),
                });
            }
        }

        if (!mapRef.current) {
            mapRef.current = new OLMap({
                target: mapContainerRef.current!,
                controls: [new ScaleLine({
                    units: preferredLenAbbr == 'm' ? 'metric' : 'imperial',
                    minWidth: 100,
                })],
                layers: [
                    /*new TileLayer({
                        source: new OSM({
                            attributions: [], // No attributions
                        }),
                    }),*/
                ],
                interactions: [],
                view: new View({
                    center,
                    zoom,
                    maxZoom,
                    minZoom,
                }),
            });

            if (newTileLayer) {
                tileLayerRef.current = newTileLayer;
                mapRef.current.addLayer(newTileLayer);
            }
        } else {
            const map = mapRef.current;
            const view = map.getView();
            view.setCenter(center);
            view.setZoom(zoom);
            view.setMaxZoom(maxZoom);
            view.setMinZoom(minZoom);

            if (newTileLayer) {
                if (tileLayerRef.current) {
                    map.removeLayer(tileLayerRef.current);
                }
                tileLayerRef.current = newTileLayer;
                map.addLayer(newTileLayer);
            }
        }
    }, [selectedPlantObj, bbCardDataSources, zoomToUse, preferredLenAbbr]);

    useEffect(() => {
        console.log("K111523 mapLayers", mapLayers)
        /* Incomplete way of updating the height, *does not update on date change*
        let heightLayer = mapLayers.filter((layer: any) => {
            console.log("K111523 layer", layer)
            console.log("K111523 layer._name", layer._name)
            console.log("K111523 layer._histogramData", layer._histogramData)
            console.log("K111523 layer._loading", layer._loading)
            return ((layer._name === "Vigor (color), Plant Height (height)") && (layer._histogramData) && (!layer._loading))
        })[0] as any;
        
        console.log("K111523 heightLayer",heightLayer);
        if (heightLayer && heightLayer._histogramData){
            setFieldMaxMinHeight(heightLayer._histogramData.histogramData.height.maxMin);
        }*/
    }, [mapLayers, dateArrayDateStringSelected]);

    useEffect(() => {
        console.log("AA092425 bbCardDataSources", bbCardDataSources)   
        console.log("AA092425 rasterDataSources", rasterDataSources)   
        console.log("AA092425 selectedPlantObj", selectedPlantObj)
        console.log("AA092425 selectedField", selectedField)
        console.log("AA092425 dataCanopyArea", dataCanopyArea)
        console.log("AA092425 dataCanopyHeight", dataCanopyHeight)
        console.log("AA092425 dataCanopyVolume", dataCanopyVolume)
        console.log("AA092425 propertyUnitsData", propertyUnitsData)
        console.log("AA092425 dateArrayIndexSelected", dateArrayIndexSelected)
        console.log("AA092425 dateArrayDateStringSelected", dateArrayDateStringSelected)
        console.log("AA092425 dataCanopyVVI", dataCanopyVVI)
        console.log("AA092425 dataCanopyPGI", dataCanopyPGI)
        console.log("AA092425 dataCanopyTIR", dataCanopyTIR)
        console.log("AA092425 dataCPI", dataCPI)
        console.log("AA092425 mapLayers", mapLayers)
        setRefreshIncrement(refreshIncrement + 1);
    }, [mapLayers, dataCPI, dataCanopyTIR, dataCanopyPGI, dataCanopyVVI, dateArrayDateStringSelected, dateArrayIndexSelected, propertyUnitsData, dataCanopyVolume, dataCanopyHeight, dataCanopyArea, selectedField, selectedPlantObj, rasterDataSources, bbCardDataSources]);
    
    useEffect(() => {
        console.log("C081925 fieldMaxMinHeight", fieldMaxMinHeight)
    }, [fieldMaxMinHeight]);

    useEffect(() => {
        console.log("C081925 localePreferences", localePreferences)
        const _preferredAreaMid = _.get(localePreferences, 'measureUnits.area.mid');
        const _preferredAreaAbbr: string =
            typeof _preferredAreaMid === 'string' ? _preferredAreaMid : _preferredAreaMid?.abbr || 'ac';

        // [LEN] preferred length unit abbr (for spacing label/input + submission)
        const _preferredLenMid = _.get(localePreferences, 'measureUnits.length.mid');
        const _preferredLenAbbr: string =
            typeof _preferredLenMid === 'string' ? _preferredLenMid : _preferredLenMid?.abbr || 'ft';
        setPreferredLenAbbr(_preferredLenAbbr);
        setPreferredAreaAbbr(_preferredLenAbbr);
        console.log("C081925", convertToPreferredUnitString(0.5, 'm', 'length', 'mid', 'abbr'))
        setFieldMaxMinHeight(_preferredLenAbbr === 'm' ? [6, 6] : [20, 20]); // Hard-code max to 6 meters or 20 feet for now
    }, [localePreferences]);

    useEffect(() => {
        if (selectedPlantObj && selectedPlantObj.geometry && selectedPlantObj.geometry.coordinates && selectedPlantObj.geometry.coordinates.length > 0){
            setViewportBB(getViewport(`@${selectedPlantObj.geometry.coordinates[1]},${selectedPlantObj.geometry.coordinates[0]},${zoomToUse}`));
        }else{
            setViewportBB(null);
        }
    }, [selectedPlantObj]);

    useEffect(() => {
        console.log("C030425 viewportBB", viewportBB);
        setBbCardDataCounter((prevState:number) => { return prevState + 1 })
    }, [viewportBB]);

    /*useEffect(() => {
        //console.log("C021424 bbCardDataSources",  bbCardDataSources)
        //console.log("C021424 bbCardDataCounter", bbCardDataCounter)
        
        //const u = bbCardDataSources.filter(layer => layer.is_visible)[0];
        const u = bbCardDataSources[0];
        //console.log("C021424 u", u)
        if (u){
            setTileLayerOverlays(new TileLayer({
                data: u.tiles,
                key:`${u.uuid}BBoverlay${bbCardDataCounter}_${refreshIncrement}`,
                id:`${u.uuid}BBoverlayId${bbCardDataCounter}_${refreshIncrement}`,
                //onViewportLoad: onTilesLoad,
                minZoom: 0,
                maxZoom: 21,
                tileSize: 256,
                renderSubLayers: (props:any) => {
                const {
                    bbox: {west, south, east, north}
                } = props.tile;
                return [
                    new BitmapLayer(props, {
                    data: null,
                    image: props.data,
                    key:`${u.uuid}BBoverlayBit${bbCardDataCounter}_${refreshIncrement}`,
                    bounds: [west, south, east, north]
                    }),
                ];
                }
            }));
        }
    }, [bbCardDataSources, bbCardDataCounter, refreshIncrement]);*/

    /* to retrieve natural color imagery */
    /*useEffect(() => {
        const t = rasterDataSources.filter(layer => layer.name === "UAS Imagery")[0];
        setTileLayer(new TileLayer({
            data: t.tiles,
            key:`${t.uuid}BBbase`,
            id:`${t.uuid}BBbaseId`,
            //onViewportLoad: onTilesLoad,
            minZoom: 0,
            maxZoom: 25,
            tileSize: 256,
            renderSubLayers: (props:any) => {
            const {
                bbox: {west, south, east, north}
            } = props.tile;
            return [
                new BitmapLayer(props, {
                data: null,
                image: props.data,
                key:`${t.uuid}BBbaseBit`,
                bounds: [west, south, east, north]
                }),
            ];
            }
        }));
    }, [rasterDataSources]);*/

    useEffect(() => {
        console.log("111323 tileLayerOverlays", tileLayerOverlays);
        console.log("111323 tileLayer", tileLayer);
    }, [ tileLayer, tileLayerOverlays]);

    useEffect(() => {
        //console.log("040724 canopyTop", canopyTop);
        //console.log("040724 canopyBottom", canopyBottom);
        setRefreshIncrement(refreshIncrement + 1);
    }, [ canopyBottom, canopyTop]);

    useEffect(() => {
        console.log("M081925 preferredLenAbbr", preferredLenAbbr);
        console.log("M081925 fieldMaxMinHeight", fieldMaxMinHeight);
        console.log("M081925 dataCanopyHeight", dataCanopyHeight);
        if (dataCanopyHeight && !loading){
            //console.log("A081925  fieldMaxMinHeight", fieldMaxMinHeight);
            //console.log("A081925 dataCanopyHeight", dataCanopyHeight);
            let _dateArrayIndexSelected = dataCanopyHeight[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected));
            //console.log("111623 dataCanopyHeight[2][dateArrayIndexSelected]", dataCanopyHeight[2][_dateArrayIndexSelected]);
            let _max = convertToPreferredUnitValue(dataCanopyHeight[2][_dateArrayIndexSelected], 'm', 'length', 'mid');
            let _min = convertToPreferredUnitValue(0.5, 'm', 'length', 'mid'); // default to 0.5 meters for now
            let _fieldMax = fieldMaxMinHeight[1]; //convertToPreferredUnitValue(fieldMaxMinHeight[1], 'm', 'length', 'mid')
            //console.log("A081925 dataCanopyHeight[2][_dateArrayIndexSelected], 0.5, fieldMaxMinHeight[1]", dataCanopyHeight[2][_dateArrayIndexSelected], 0.5, fieldMaxMinHeight[1]);
            //console.log("A081925 _max, _min, _fieldMax", _max, _min, _fieldMax);
            if (_max != null && _fieldMax) {
                setCanopyTop((_max/_fieldMax) * 100);
            }
            if (_min != null && _fieldMax) {
                setCanopyBottom((_min/_fieldMax) * 100);
            } 
        }
    }, [ fieldMaxMinHeight, dataCanopyHeight, dateArrayDateStringSelected]);

    const rounding = (value:number) => {
        //console.log("B053124 value", value);
        //console.log("B053124 (Math.round(value * 10) / 10)", (Math.round(value * 10) / 10));
        return(Math.round(value * 10) / 10);
    }
    const mapChild = useMemo(() => {
        if (!tileLayerOverlays || tileLayerOverlays.length === 0 || !viewportBB || loading) {
            return;
        }
        console.log("A061224 bbCardDataCounter" , bbCardDataCounter)
        console.log("A061224 refreshIncrement" , refreshIncrement)
        console.log("A061224 tileLayerOverlays" , tileLayerOverlays)
        return (
            /*<DeckGL
                //initialViewState={viewportBB}
                viewState={{
                    ...viewportBB,
                    maxZoom:21
                }}
                key={`BB-map${bbCardDataCounter}_${refreshIncrement}`}
                controller={true}
                layers={[ tileLayerOverlays ]}
            >     
                <StaticMap> 
                    <ScaleControl style={{right: 10, bottom: 10}} maxWidth={100} />   
                </StaticMap>        
            </DeckGL>*/
            <div ref={mapContainerRef} style={{ width: "100%", height: "400px", background: "#eee", border: "1px solid #ccc" }} />
        )
    }, [/*bbCardDataCounter, refreshIncrement,*/ tileLayerOverlays, loading ]);

    return (
        //(!dataCanopyArea && !dataCanopyHeight && !dataCanopyVolume && !dataCanopyVVI && !dataCanopyPGI && !dataCanopyTIR && !dataCPI) 
        //? <>
        //    <div className="text-muted text-sm mt-2">Data unavailable for this date.</div>
        //</>
        //: <>
        <>
        <div ref={mapContainerRef} style={{ width: "250px", height: "250px", background: "#fff", border: "1px solid #fff", position:'absolute', left:'110px' }} />
        <div 
            className={"bb-card-mug-shot"}
            key={`bb-card-mug-shot-${bbCardDataCounter}_${refreshIncrement}`}
            >
            { ( loading || !viewportBB ) 
            ? <div className="text-muted text-sm mt-2">Loading...</div>
            : <>
            <div className={"bb-card-mug-shot-chart-container"}>
                <div className="bb-card-mug-shot-annotations">
                    <div className="-height">Height</div>
                    <div 
                        className="-canopy-top"
                        style={{top:`calc(${100 - canopyTop}% + 5px)`}}
                    >
                        { /*console.log("C053124 ", dataCanopyHeight ? dataCanopyHeight[2][dataCanopyHeight[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))] : "")*/}
                        { /*dataCanopyHeight ? `${rounding(dataCanopyHeight[2][dataCanopyHeight[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))])} m` : "" */}
                        { dataCanopyHeight ? `${convertToPreferredUnitString(
                            dataCanopyHeight[2][dataCanopyHeight[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))]
                            , 'm', 'length', 'mid', 'abbr')}` : "" }
                    </div>
                    <div 
                        className="-canopy-bottom"
                        style={{ top:`calc(${100 - canopyBottom }% - 12px)`}}
                    >
                        {/*`${rounding(0.5)} preferredLenAbbr`*/}
                        {convertToPreferredUnitString(0.5, 'm', 'length', 'mid', 'abbr')}
                    </div>
                    <div className="-high">{ fieldMaxMinHeight ? `${rounding(fieldMaxMinHeight[1])} ${preferredLenAbbr}` : "" }</div>
                    <div className="-low">{ `${0} ${preferredLenAbbr}` }</div>
                </div>
                <div className={"bb-card-mug-shot-heightbar"}>
                    <div className={"bb-card-mug-shot-heightbar-back-bar"}>
                        <div 
                            className={"bb-card-mug-shot-heightbar-front-bar"}
                            style={{height:`${canopyTop - canopyBottom}%`, top:`${100 - canopyTop}%`}}
                        ></div>
                    </div>
                </div>
                <div className={"bb-card-mug-shot-map"}>  
                    {/*mapChild
                    <div ref={mapContainerRef} style={{ width: "250px", height: "250px", background: "#eee", border: "1px solid #ccc" }} />*/}
                </div>
                <div className={"bb-card-mug-shot-stats"}>
                    <div className={"bb-card-mug-shot-stat-1"}>
                        <span className="stat-text">{dataCanopyVVI ? rounding(dataCanopyVVI[2][dataCanopyVVI[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))]) : "n/a"}</span><br/>
                        <span>Vigor</span>
                    </div>
                    <div className={"bb-card-mug-shot-stat-2"}>
                        <span className="stat-text">{dataCanopyPGI ? rounding(dataCanopyPGI[2][dataCanopyPGI[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))]) : "n/a"}</span><br/>
                        <span>Pigment</span>
                    </div>
                </div>
            </div>
            <div className={"bb-card-mug-shot-stat-container"}>
                <div className={"bb-card-mug-shot-stat-heightbar"}>
                    {/*<span className="stat-text">{dataCanopyVolume ? rounding(dataCanopyVolume[2][dataCanopyVolume[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))]) : "n/a"}</span><br/>*/}
                    <span className="stat-text">{dataCanopyVolume ? (() => {
                        const convertedValue = convertToPreferredUnitValue(dataCanopyVolume[2][dataCanopyVolume[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))],'m3', 'volume', 'mid');
                        return convertedValue != null ? rounding(convertedValue) : "n/a";
                    })() : "n/a"}</span><br/>
                    <span>Volume ({preferredLenAbbr}<sup>3</sup>)</span>
                </div>
                <div className={"bb-card-mug-shot-stat-map"}>
                    {/*<span className="stat-text">{dataCanopyArea ? rounding(dataCanopyArea[2][dataCanopyArea[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))]) : "n/a"}</span><br/>*/}
                    <span className="stat-text">{dataCanopyArea ? (() => {
                        const convertedValue = convertToPreferredUnitValue(dataCanopyArea[2][dataCanopyArea[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))],'m2', 'area', 'small');
                        return convertedValue != null ? rounding(convertedValue) : "n/a";
                    })() : "n/a"}</span><br/>
                    <span>Area ({preferredLenAbbr}<sup>2</sup>)</span>
                </div>
                <div className={"bb-card-mug-shot-stat-stats"}>
                    <span className="stat-text">{dataCPI ? rounding(dataCPI[2][dataCPI[3].findIndex((date: string) => date && date.startsWith(dateArrayDateStringSelected))]) : "n/a"}</span><br/>
                    <span>Productivity</span>
                </div>
            </div>
            </>}
        </div></>
    );
}

export default AboveWidgetImagery;